export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID || "c43700f1-1d03-48f3-9057-021abb7de15e",
        authority: "https://login.microsoftonline.com/organizations",
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
};

export const loginRequest = {
    scopes: [`api://${process.env.REACT_APP_CLIENT_ID || "c43700f1-1d03-48f3-9057-021abb7de15e"}/access_as_user`],
};
